import { createStore, applyMiddleware } from "redux";
import { rootReducer } from "./RootReducer";
import thunk from "redux-thunk";

export function createPolityStore() {
  return createStore(rootReducer, applyMiddleware(thunk));
}
